import { render, staticRenderFns } from "./FormBookingChannel.vue?vue&type=template&id=26a9d9a4"
import script from "./FormBookingChannel.vue?vue&type=script&lang=js"
export * from "./FormBookingChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports